import { jsx } from 'react/jsx-runtime';
import { Grid, TextField } from '@mui/material';

const Text = ({ label, value = '', name, handleChange }) => {
    return (jsx(Grid, Object.assign({ item: true, lg: 6, md: 12, sm: 12, xs: 12 }, { children: jsx(TextField, { fullWidth: true, value: value, label: label, onChange: handleChange, name: `${name}` }) })));
};

export { Text };
